// Protective wording for benchmark references shown in the product (Hugo Andrade, 2026-10-21, ENTRAID-347).
// onGuard keeps CIS control references in reports and the portal, but only as a soft readiness indication: never
// compliance, certification, attestation or endorsement. Marketing (listing, site) carries no CIS mention at all
// (scripts/marketplace-listing.mjs FORBIDDEN). One text, shared by the portal and the report Lambda through the
// synced compliance copies (scripts/sync-compliance.sh); never re-word it per screen.
export const CIS_FRAMEWORK_ID = 'cis-m365';

export const CIS_NOTICE = 'Checks informed by the CIS Microsoft 365 Foundations Benchmark. Readiness indication only; not a CIS certification or endorsement. CIS is a trademark of the Center for Internet Security, which does not endorse onGuard.';

const NOTICES = Object.freeze({ [CIS_FRAMEWORK_ID]: CIS_NOTICE });

/** The protective notice for a framework id, or null when the framework needs none. */
export function frameworkNotice(frameworkId) {
  return typeof frameworkId === 'string' && Object.prototype.hasOwnProperty.call(NOTICES, frameworkId) ? NOTICES[frameworkId] : null;
}

// Phrases that would turn a readiness indication into a claim. Product copy that names CIS must never use them
// (checked with the notice itself removed, since it says what onGuard is not).
export const CIS_BANNED_CLAIMS = Object.freeze([
  /\bCIS[- ](?:compliant|compliance|certified|certification|approved|endorsed|attested|attestation)\b/i,
  /\b(?:compliant|complies|comply|certified|attested|endorsed|approved)\s+(?:with|by|against|to|under)\s+(?:the\s+)?(?:CIS|Center for Internet Security)\b/i,
]);
